<button
  #renderSelectSelector
  data-e2e="open-listbox-selector"
  class="listbox-selector"
  type="button"
  (click)="toggle()"
  [attr.title]="text"
  [attr.aria-expanded]="expanded"
  [attr.aria-controls]="'listbox-' + id">
    <img
      *ngIf="image"
      class="image"
      src="{{image}}"
      alt="preview" />
    <div class="text-wrapper">
      <span class="text">
        {{ text ?? defaultValue }}
      </span>
    </div>
    <svg class="icon">
      <use href="#dropdown"></use>
    </svg>
  </button>
  <div
    #collapsible
    class="listbox-collapsible"
    [attr.id]="'listbox-' + this.id"
    [attr.aria-hidden]="!expanded">
    <div
      class="search"
      *ngIf="withFilter"
      >
      <input
        [attr.label]="searchLabel"
        #search
        class="search-input"
        (keyup)="filterOptions($event)"
      >
    </div>
    <ng-content></ng-content>
  </div>
